export const FeedIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" fill="none" className={className}>
    <rect x="4" y="4" width="72" height="72" rx="12" stroke="currentColor" strokeWidth="6" />
    <line x1="40" y1="4" x2="40" y2="76" stroke="currentColor" strokeWidth="6" />
    <polyline points="22,48 22,32" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    <polyline
      points="15,39 22,32 29,39"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline points="58,32 58,48" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    <polyline
      points="51,41 58,48 65,41"
      stroke="currentColor"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
